// @ts-nocheck
import type { Question } from '../types';

export const mandatorySignsQuestions: Question[] = [
  {
    id: 'q-mand-sign-1',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-1o1', text: 'No entry for bicycles' },
      { id: 'q-mand-sign-1o2', text: 'End of the path for cyclists and mopeds' },
      { id: 'q-mand-sign-1o3', text: 'Bicycle parking area' }
    ],
    answerId: 'q-mand-sign-1o2',
    explanation: 'This sign indicates the end of the mandatory path for cyclists and mopeds. After this sign, cyclists and moped riders are no longer required to use a designated path.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-1.jpg',
    imageHint: 'end of path for cyclists and mopeds'
  },
  {
    id: 'q-mand-sign-2',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-2o1', text: 'Mandatory lane for tractors' },
      { id: 'q-mand-sign-2o2', text: 'Agricultural vehicles route' },
      { id: 'q-mand-sign-2o3', text: 'Tractors must use this route' }
    ],
    answerId: 'q-mand-sign-2o1',
    explanation: 'This blue circular sign with a tractor symbol indicates a mandatory lane that must be used by tractors and agricultural vehicles.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-2.jpg',
    imageHint: 'mandatory lane for tractors'
  },
  {
    id: 'q-mand-sign-3',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-3o1', text: 'Roundabout ahead' },
      { id: 'q-mand-sign-3o2', text: 'Direction of traffic on roundabout' },
      { id: 'q-mand-sign-3o3', text: 'Turn left or right' }
    ],
    answerId: 'q-mand-sign-3o2',
    explanation: 'This blue circular sign with arrows indicates the mandatory direction of traffic on a roundabout. In the Netherlands, traffic always circulates clockwise on roundabouts (right-hand traffic rules). You must follow the direction shown by the arrows.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-3.jpg',
    imageHint: 'direction of traffic on roundabout'
  },
  {
    id: 'q-mand-sign-4',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-4o1', text: 'No entry for trams' },
      { id: 'q-mand-sign-4o2', text: 'End of the lane for trams' },
      { id: 'q-mand-sign-4o3', text: 'Tram stop ahead' }
    ],
    answerId: 'q-mand-sign-4o2',
    explanation: 'This sign indicates the end of the mandatory lane for trams. After this sign, trams are no longer required to use a designated lane.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-4.jpg',
    imageHint: 'end of lane for trams'
  },
  {
    id: 'q-mand-sign-5',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-5o1', text: 'Turning right compulsory' },
      { id: 'q-mand-sign-5o2', text: 'No right turn' },
      { id: 'q-mand-sign-5o3', text: 'Road bends right' }
    ],
    answerId: 'q-mand-sign-5o1',
    explanation: 'This blue circular sign with a white arrow pointing right indicates that turning right is compulsory. Drivers must turn right.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-5.jpg',
    imageHint: 'turning right compulsory'
  },
  {
    id: 'q-mand-sign-6',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-6o1', text: 'Turning left or right mandatory' },
      { id: 'q-mand-sign-6o2', text: 'Vehicles may choose left or right' },
      { id: 'q-mand-sign-6o3', text: 'No vehicles allowed' }
    ],
    answerId: 'q-mand-sign-6o1',
    explanation: 'This blue circular sign with branching arrows indicates that turning left or right is mandatory. Drivers must choose one of these directions.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-6.jpg',
    imageHint: 'turning left or right mandatory'
  },
  {
    id: 'q-mand-sign-7',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-7o1', text: 'Compulsory direction ahead' },
      { id: 'q-mand-sign-7o2', text: 'Compulsory direction right' },
      { id: 'q-mand-sign-7o3', text: 'Pass on right only' }
    ],
    answerId: 'q-mand-sign-7o3',
    explanation: 'This blue circular sign with a white arrow pointing right indicates that passing is only allowed on the right side. Drivers must pass other vehicles on the right.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-7.jpg',
    imageHint: 'pass on right only'
  },
  {
    id: 'q-mand-sign-8',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-8o1', text: 'Bus stop ahead' },
      { id: 'q-mand-sign-8o2', text: 'No buses allowed' },
      { id: 'q-mand-sign-8o3', text: 'Mandatory lane for trams' }
    ],
    answerId: 'q-mand-sign-8o3',
    explanation: 'This blue circular sign with a tram symbol indicates a mandatory lane for trams. Trams must use this designated lane.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-8.jpg',
    imageHint: 'mandatory lane for trams'
  },
  {
    id: 'q-mand-sign-9',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-9o1', text: 'Compulsory direction ahead' },
      { id: 'q-mand-sign-9o2', text: 'Compulsory direction right' },
      { id: 'q-mand-sign-9o3', text: 'Driving straight ahead or turning right mandatory' }
    ],
    answerId: 'q-mand-sign-9o3',
    explanation: 'This blue circular sign with two arrows (one straight, one right) indicates that driving straight ahead or turning right is mandatory. Both directions are required options.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-9.jpg',
    imageHint: 'driving straight ahead or turning right mandatory'
  },
  {
    id: 'q-mand-sign-10',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-mand-sign-10o1', text: 'Mandatory path for equestrians' },
      { id: 'q-mand-sign-10o2', text: 'Horse riders prohibited' },
      { id: 'q-mand-sign-10o3', text: 'Horse crossing ahead' }
    ],
    answerId: 'q-mand-sign-10o1',
    explanation: 'This blue circular sign with a horse rider symbol indicates a mandatory path for equestrians. Horse riders must use this designated path.',
    subject: 'Mandatory Signs',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/mandatory/q-mand-sign-10.jpg',
    imageHint: 'mandatory path for equestrians'
  },
  {
    id: 'q-mand-sign-11',
    topic: 'General',
    question: 'What color is a mandatory instruction sign?',
    options: [
      { id: 'q-mand-sign-11o1', text: 'Red circle with white symbol' },
      { id: 'q-mand-sign-11o2', text: 'Blue rectangle with white symbol' },
      { id: 'q-mand-sign-11o3', text: 'Yellow triangle with red border' }
    ],
    answerId: 'q-mand-sign-11o2',
    explanation: 'Mandatory instruction signs are blue rectangular signs with white symbols. These signs convey instructions and regulations that must be followed, such as mandatory lanes and directions.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-12',
    topic: 'General',
    question: 'What does a blue arrow sign pointing straight ahead indicate?',
    options: [
      { id: 'q-mand-sign-12o1', text: 'Straight ahead is recommended' },
      { id: 'q-mand-sign-12o2', text: 'You must drive straight ahead' },
      { id: 'q-mand-sign-12o3', text: 'You may drive straight ahead' }
    ],
    answerId: 'q-mand-sign-12o2',
    explanation: 'A blue circle with a white arrow pointing straight ahead is a mandatory instruction sign indicating that you must proceed straight ahead. You cannot turn left or right at this location.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-13',
    topic: 'General',
    question: 'What does a mandatory sign with a left arrow indicate?',
    options: [
      { id: 'q-mand-sign-13o1', text: 'You must turn left at this location' },
      { id: 'q-mand-sign-13o2', text: 'Turning left is prohibited' },
      { id: 'q-mand-sign-13o3', text: 'You may turn left if safe' }
    ],
    answerId: 'q-mand-sign-13o1',
    explanation: 'A blue circular sign with a white arrow pointing left is a mandatory instruction requiring you to turn left. You must follow this instruction and cannot continue straight.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-14',
    topic: 'General',
    question: 'What does a mandatory sign showing two arrows (left and right) indicate?',
    options: [
      { id: 'q-mand-sign-14o1', text: 'You must choose between turning left or right' },
      { id: 'q-mand-sign-14o2', text: 'Both directions are equally recommended' },
      { id: 'q-mand-sign-14o3', text: 'You can continue straight' }
    ],
    answerId: 'q-mand-sign-14o1',
    explanation: 'A blue circular sign with two arrows (one pointing left, one pointing right) indicates that you must turn either left or right. You cannot continue straight.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-15',
    topic: 'General',
    question: 'What does a sign showing a bicycle symbol on a blue background indicate?',
    options: [
      { id: 'q-mand-sign-15o1', text: 'Bicycles are prohibited' },
      { id: 'q-mand-sign-15o2', text: 'This is a mandatory bicycle path' },
      { id: 'q-mand-sign-15o3', text: 'Bicycle rental is available' }
    ],
    answerId: 'q-mand-sign-15o2',
    explanation: 'A blue sign with a white bicycle symbol indicates a mandatory bicycle path. Cyclists must use this path, and it is reserved for bicycles and sometimes mopeds.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-16',
    topic: 'General',
    question: 'What does a pedestrian crossing mandatory sign look like?',
    options: [
      { id: 'q-mand-sign-16o1', text: 'Blue rectangle with white pedestrian figure' },
      { id: 'q-mand-sign-16o2', text: 'Red circle with white pedestrian figure' },
      { id: 'q-mand-sign-16o3', text: 'White triangle with red border' }
    ],
    answerId: 'q-mand-sign-16o1',
    explanation: 'A blue rectangular sign with a white pedestrian figure indicates a mandatory pedestrian crossing. This marks an official crossing area where pedestrians must cross.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-17',
    topic: 'General',
    question: 'What is indicated by a blue lane marking sign with a car symbol?',
    options: [
      { id: 'q-mand-sign-17o1', text: 'This lane is reserved for motor vehicles only' },
      { id: 'q-mand-sign-17o2', text: 'Motor vehicles are prohibited' },
      { id: 'q-mand-sign-17o3', text: 'Vehicles may park here' }
    ],
    answerId: 'q-mand-sign-17o1',
    explanation: 'A blue sign with a car symbol indicates a lane or road reserved for motor vehicles only. Other vehicles and road users cannot use this facility.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-18',
    topic: 'General',
    question: 'What does a minimum speed mandatory sign indicate?',
    options: [
      { id: 'q-mand-sign-18o1', text: 'You must not exceed this speed' },
      { id: 'q-mand-sign-18o2', text: 'You must maintain at least this minimum speed' },
      { id: 'q-mand-sign-18o3', text: 'This is the recommended speed' }
    ],
    answerId: 'q-mand-sign-18o2',
    explanation: 'A blue circular sign with numbers and an upward arrow indicates a mandatory minimum speed. You must drive at least at this speed, except when conditions make it unsafe.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-19',
    topic: 'General',
    question: 'What does a sign showing a bus symbol on a blue background indicate?',
    options: [
      { id: 'q-mand-sign-19o1', text: 'Buses are prohibited' },
      { id: 'q-mand-sign-19o2', text: 'This is a mandatory bus lane' },
      { id: 'q-mand-sign-19o3', text: 'A bus stop is ahead' }
    ],
    answerId: 'q-mand-sign-19o2',
    explanation: 'A blue sign with a white bus symbol indicates a mandatory bus lane. Only buses are permitted to use this lane during specified times.',
    subject: 'Mandatory Signs'
  },
  {
    id: 'q-mand-sign-20',
    topic: 'General',
    question: 'What is the purpose of mandatory signs in traffic?',
    options: [
      { id: 'q-mand-sign-20o1', text: 'To give advice and recommendations' },
      { id: 'q-mand-sign-20o2', text: 'To convey orders and instructions that must be obeyed' },
      { id: 'q-mand-sign-20o3', text: 'To warn of potential hazards' }
    ],
    answerId: 'q-mand-sign-20o2',
    explanation: 'Mandatory signs convey orders and instructions that all road users must obey. Failing to follow a mandatory sign can result in fines or penalties.',
    subject: 'Mandatory Signs'
  }
];